export default __webpack_public_path__ + "images/b53313a39c5987ce82b91fb58284066e.svg";